import { render, staticRenderFns } from "./budget-proposal-template.vue?vue&type=template&id=3b2eb112&"
import script from "./budget-proposal-template.vue?vue&type=script&lang=js&"
export * from "./budget-proposal-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports